export const dateFormat = 'DD.MM.YYYY';
export const dateTimeFormat = 'DD.MM.YYYY HH:mm';
